export const PINCODE_COUNT_DOWN_TIME = 60;
export const PINCODE_LENGTH = 4;
